/** The maker's mark: A&W Engineering Works.
 *
 *  Vector text rather than the supplied PNG, for three reasons. The PNG has no alpha
 *  channel — a solid white background — and every surface in this app is a warm
 *  off-white, so it would sit in a visible white rectangle on the cream rail. At
 *  285px wide it would also be soft on a retina screen. And a component can be set at
 *  four different sizes without four different files.
 *
 *  Not pixel-identical to the original artwork: it is set in the app's own typeface so
 *  it belongs with everything around it rather than sitting beside it. The one thing
 *  carried over exactly is the ampersand — smaller than the letters and grey, which is
 *  the whole character of the mark.
 *
 *  `currentColor` on the letters, so the surrounding text class decides how loud it is;
 *  the ampersand keeps its own grey, being the one deliberate colour in the artwork.
 */
type Props = {
  /** Rendered height in px. Width follows from the viewBox — roughly 2.5× this. */
  height?: number
  className?: string
}

export function AwLogo({ height = 28, className = '' }: Props) {
  return (
    <svg
      viewBox="0 0 285 116"
      height={height}
      className={className}
      // A logo is content, not decoration: named for a screen reader rather than
      // announced as an unlabelled graphic.
      role="img"
      aria-label="A&amp;W Engineering Works"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>A&amp;W Engineering Works</title>
      <text
        x="142"
        y="68"
        textAnchor="middle"
        fontFamily="'IBM Plex Sans', system-ui, sans-serif"
        fontSize="66"
        fontWeight="400"
        fill="currentColor"
      >
        A<tspan fontSize="36" fill="#A6A6A6">&amp;</tspan>W
      </text>
      <text
        x="142"
        y="104"
        textAnchor="middle"
        fontFamily="'IBM Plex Sans', system-ui, sans-serif"
        fontSize="30"
        fontWeight="400"
        fill="currentColor"
      >
        Engineering Works
      </text>
    </svg>
  )
}
